import { H3, Image, P, SpacerWrapper, Strong, TypeWrapper } from '@ahmdigital/ui';
import React from 'react';

type PersonTileProps = {
  image: string;
  name: string;
  quote: string;
  startYear: number;
};

const PersonTile = ({ image, name, quote, startYear }: PersonTileProps) => (
  <SpacerWrapper variant="paddingBottomSpacer10">
    <Image src={image} role="presentation" />
    <TypeWrapper variant="simpleBit">
      <H3 variant="marginTopSpacer10">{name}</H3>
      <P looksLike="h5" variant={['regular', 'marginBottomSpacer11']}>
        ‘{quote}’
      </P>
    </TypeWrapper>
    <Strong variant="paddingBottomSpacer10">Started at ahm in {startYear}</Strong>
  </SpacerWrapper>
);

export default PersonTile;
